
import React, { useEffect, useState, useRef, } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Switch,
    Select,
    useCRUDController,
    InputNumber,
    Textarea
} from '../../ui/ot'
import { useTranslation } from "react-i18next";

const TagStructureManagementForm = ({
    propsForm,
    field,
    onFormFinish = () => { },
    keyPrefix = "cataloging.tag_structure_management",
    parentItemTypesOptions,
    parentLibraryOptions,
    parentAuthorisedCategoryOptions,

}) => {

    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const axiosMode = Form.useWatch([field?.name ?? '', 'axiosMode'].join('.'), form)

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        if (!parentItemTypesOptions) {
            authorisedCategoryController.getData({})
        }
    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });

    };
    const onValuesChange = (value, { name, type }) => {

        let formValues = null;
        formValues = form.getFieldsValue();
    };


    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    const authorisedCategoryController = useCRUDController({ apiRoute: "/koha/authorised_values/category" })
    useEffect(() => {
        setDataInitialization();
    }, []);


    return (
        <Row>
            <Col span={24}>
                <Form
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                axiosMode={axiosMode}
                                field={field}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={form.setFieldValue}
                                setCount={setCount}
                                keyPrefix={keyPrefix}
                                parentAuthorisedCategoryOptions={parentAuthorisedCategoryOptions ? parentAuthorisedCategoryOptions : authorisedCategoryController.ResponseData}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    field,
    initialValues = {},
    keyPrefix = "library",
    axiosMode,
    parentAuthorisedCategoryOptions
}) => {
    const { t } = useTranslation('translation', { keyPrefix })

    return (
        <>
            <Row>
                <Col span={24}>
                    <Row>
                        <Col span={24} >
                            <Form.Item


                                {...field}
                                name={[field?.name ?? '', 'tagfield']}
                                fieldKey={[field?.fieldKey ?? '', 'tagfield']}
                                label={t('tagfield')}
                                rules={[{ required: true, message: t('please_input_item') }]}
                            >
                                <Input maxLength={3} disabled={axiosMode === "patch"} />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item


                                {...field}
                                name={[field?.name ?? '', 'liblibrarian']}
                                fieldKey={[field?.fieldKey ?? '', 'liblibrarian']}
                                label={t('liblibrarian')}
                                rules={[{ required: true, message: t('please_input_item') }]}
                            >

                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item


                                {...field}
                                name={[field?.name ?? '', 'libopac']}
                                fieldKey={[field?.fieldKey ?? '', 'libopac']}
                                label={t('libopac')}
                                rules={[{ required: true, message: t('please_input_item') }]}
                            >

                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={24} >
                            <Form.Item


                                {...field}
                                name={[field?.name ?? '', 'repeatable']}
                                fieldKey={[field?.fieldKey ?? '', 'repeatable']}
                                label={t('repeatable')}

                            >
                                <Switch
                                    mode='number'
                                    checkedChildren={t("yes")}
                                    unCheckedChildren={t("no")}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item


                                {...field}
                                name={[field?.name ?? '', 'mandatory']}
                                fieldKey={[field?.fieldKey ?? '', 'mandatory']}
                                label={t('mandatory')}

                            >
                                <Switch
                                    mode='number'
                                    checkedChildren={t("yes")}
                                    unCheckedChildren={t("no")}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item


                                {...field}
                                name={[field?.name ?? '', 'important']}
                                fieldKey={[field?.fieldKey ?? '', 'important']}
                                label={t('important')}

                            >
                                <Switch
                                    mode='number'
                                    checkedChildren={t("yes")}
                                    unCheckedChildren={t("no")}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item


                                {...field}
                                name={[field?.name ?? '', 'authorised_value']}
                                fieldKey={[field?.fieldKey ?? '', 'authorised_value']}
                                label={t('authorised_value')}
                                extra={t('indicator_value_limit')}
                            >
                                <Select
                                    allowClear={true}
                                    options={parentAuthorisedCategoryOptions.map((value) => {
                                        return {
                                            ...value,
                                            label: `${value?.category}`,
                                            value: value?.category
                                        }
                                    })}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item


                                {...field}
                                name={[field?.name ?? '', 'ind1_defaultvalue']}
                                fieldKey={[field?.fieldKey ?? '', 'ind1_defaultvalue']}
                                label={t('ind1_defaultvalue')}

                            >
                                <Input maxLength={1} />

                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item


                                {...field}
                                name={[field?.name ?? '', 'ind2_defaultvalue']}
                                fieldKey={[field?.fieldKey ?? '', 'ind2_defaultvalue']}
                                label={t('ind2_defaultvalue')}

                            >
                                <Input maxLength={1} />

                            </Form.Item>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};





export default TagStructureManagementForm;
